import { render, staticRenderFns } from "./Ads03.vue?vue&type=template&id=bd84fdf0&scoped=true"
import script from "./Ads03.vue?vue&type=script&lang=js"
export * from "./Ads03.vue?vue&type=script&lang=js"
import style0 from "./Ads03.vue?vue&type=style&index=0&id=bd84fdf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd84fdf0",
  null
  
)

export default component.exports